import { routes as Abastecimento } from '@/pages/Abastecimento'
import { routes as Adm } from '@/pages/Adm'
import { routes as Carro } from '@/pages/Carro'
import { routes as Cliente } from '@/pages/Cliente'
import { routes as Dashboard } from '@/pages/Dashboard'
import { routes as Empresa } from '@/pages/Empresa'
import { routes as Financeiro } from '@/pages/Financeiro'
import { routes as GrupoEmpresa } from '@/pages/GrupoEmpresa'
import { routes as Login } from '@/pages/Login'
import { routes as Motorista } from '@/pages/Motorista'
import { routes as NiveisAcesso } from '@/pages/NiveisAcesso'
import { routes as Pagamento } from '@/pages/Pagamento'
import { routes as Permissao } from '@/pages/Permissao'
import { routes as Plano } from '@/pages/Plano'
import { routes as Relatorio } from '@/pages/Relatorio'
import { routes as RH } from '@/pages/RH'
import { routes as Seguimento } from '@/pages/Seguimento'
import { routes as SMS } from '@/pages/SMS'
import { routes as Usuario } from '@/pages/Usuario'

export default[ 
    {path: '/', redirect: '/dashboard'},
    { path: '*', redirect: '/login' },
    ...Abastecimento,
    ...Adm,
    ...Carro,
    ...Cliente,
    ...Dashboard,
    ...Empresa,
    ...Financeiro,
    ...GrupoEmpresa,
    ...Login,
    ...Motorista,
    ...NiveisAcesso,
    ...Pagamento,
    ...Permissao,
    ...Plano,
    ...Relatorio,
    ...RH,
    ...Seguimento,
    ...SMS,
    ...Usuario,
];

